import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PsFooterModule } from '@paysafe-ui/components/footer';
import { FooterComponent } from './footer/footer.component';
import { PsIconModule } from '@paysafe-ui/components/icon';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderLinksComponent } from './header-links/header-links.component';
import { PsHeaderModule } from '@paysafe-ui/components/header';
import { DeleteItemDialogComponent } from '../business-account/components/delete-item-dialog/delete-item-dialog.component';
import { PsDialogModule } from '@paysafe-ui/components/dialog';
import { PsButtonModule } from '@paysafe-ui/components/button';
import { PipesModule } from './pipes/pipes.module';
import { ContactPersonalInformationComponent } from './contact-personal-information/contact-personal-information.component';
import { PsFormFieldModule } from '@paysafe-ui/components/form-field';
import { PsInputModule } from '@paysafe-ui/components/input';
import { ContactBusinessInformationComponent } from './contact-business-information/contact-business-information.component';
import { PsSelectModule } from '@paysafe-ui/components/select';
import { ReactiveFormsModule } from '@angular/forms';
import { PsDividerModule } from '@paysafe-ui/components/divider';
import { SocialMediaComponent } from './social-media/social-media.component';
import { HeaderLogoComponent } from './header-logo/header-logo.component';

@NgModule({
  declarations: [
    FooterComponent,
    HeaderLinksComponent,
    HeaderLogoComponent,
    DeleteItemDialogComponent,
    ContactPersonalInformationComponent,
    ContactBusinessInformationComponent,
    SocialMediaComponent
  ],
  exports: [
    FooterComponent,
    HeaderLinksComponent,
    HeaderLogoComponent,
    ContactPersonalInformationComponent,
    ContactBusinessInformationComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PsFooterModule,
    PsIconModule,
    TranslateModule,
    PsHeaderModule,
    PsDialogModule,
    PsButtonModule,
    PipesModule,
    PsFormFieldModule,
    PsInputModule,
    PsSelectModule,
    PsDividerModule
  ]
})
export class SharedModule {}
